import '../../styles/templates/product.pcss';
import {load} from '@shopify/theme-sections';
import '../sections/product';

load('*');
